import { getFlagIcon } from './flags';
import { getFamFamFamIcon } from './famfamfam';
import { getFaIcon, getBugIcon  } from './fontawesome/fontawesome';
import { getCustomIcon } from './custom';

const CUSTOM = 'custom';
const FLAGS = 'flags';
const FONTAWESOME = 'fontawesome';
const FAMFAMFAM = 'famfamfam';

const icons = {};

const registerIcons = (iconSet, resolver) => {
    icons[iconSet] = resolver;
}

const getIcon = (iconSet, code) => {   
    const resolver = icons[iconSet];
    let result = null;
      
    if (resolver !== undefined) {
        result = resolver(code);
    } else {
        console.warn("Unsupported icon set: ", iconSet);
    }

    if (result == null) {
        console.warn("Icon ", code, " not found in set ", iconSet);
        result = getBugIcon();
    }

    return result;
}

registerIcons(CUSTOM, getCustomIcon);
registerIcons(FLAGS, getFlagIcon);
registerIcons(FONTAWESOME, getFaIcon);
registerIcons(FAMFAMFAM, getFamFamFamIcon);

export {
    getIcon
}